import type { OverviewFieldDescriptor } from './types';

/**
 * Strips the '-BRIGHT' suffix and converts to title case.
 * e.g. "ACTIVE UNDER CONTRACT-BRIGHT" → "Active Under Contract"
 */
const cleanStatusLabel = (raw: string): string => {
  const stripped = raw.replace(/-BRIGHT$/i, '');
  return stripped.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase());
};

/**
 * All fields the overview needs, organized by section.
 *
 * Resolution type is auto-detected from FieldMetadata — NOT declared here.
 * Adding/removing a field = one array entry change. The same array works
 * across tenants; metadata drives the resolution behavior.
 */
export const OVERVIEW_FIELDS: OverviewFieldDescriptor[] = [
  // ── MLS Details section ──
  {
    fieldKey: 'PROPERTY_TYPE',
    label: 'Property Type',
    section: 'listing',
    filterable: true,
  },
  {
    fieldKey: 'MLS_STATUS',
    label: 'Status',
    section: 'listing',
    filterable: true,
    transformLabel: cleanStatusLabel,
  },
  {
    fieldKey: 'LISTING_ID',
    label: 'MLS #',
    section: 'listing',
    filterable: true,
  },
  {
    fieldKey: 'TAX_ID',
    label: 'Tax ID #',
    section: 'listing',
    filterable: true,
  },
  {
    fieldKey: 'IS_OFFICE_EXCLUSIVE',
    label: 'Office Exclusive',
    section: 'listing',
    filterable: true,
    type: 'boolean',
  },
  {
    fieldKey: 'IS_DRAFT_ONLY',
    label: 'Draft Only',
    section: 'listing',
    filterable: true,
    type: 'boolean',
  },
  // ── Agents section ──
  {
    fieldKey: 'LIST_AGENT_FULL_NAME',
    label: 'List Agent',
    section: 'agent',
    filterable: true,
  },
  {
    fieldKey: 'CO_LIST_AGENT_FULL_NAME',
    label: 'Co-List Agent',
    section: 'agent',
    filterable: true,
  },

  // ── Dates section ──
  {
    fieldKey: 'EXPIRATION_DATE',
    label: 'Expiration Date',
    section: 'dates',
    filterable: true,
    type: 'date',
  },

  // ── Address section ──
  {
    fieldKey: 'STATE_OR_PROVINCE',
    label: 'State',
    allLabel: 'All States',
    section: 'location',
    filterable: true,
  },
  {
    fieldKey: 'COUNTY',
    label: 'County',
    section: 'location',
    filterable: true,
  },
  {
    fieldKey: 'CITY',
    label: 'City',
    section: 'location',
    filterable: true,
  },
  {
    fieldKey: 'POSTAL_CODE',
    label: 'Zip',
    section: 'location',
    filterable: true,
  },
  {
    fieldKey: 'STREET_NAME',
    label: 'Street Name',
    section: 'location',
    filterable: true,
  },
  {
    fieldKey: 'STREET_DIR_PREFIX',
    label: 'Street Direction',
    section: 'location',
    filterable: true,
  },
];
